/**
 * VoicemailFilter.js
 * Talkroute
 *
 * Created by Vel Genov on 2/16/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

import React from "react";
import { useDispatch } from "react-redux";
import { applyVoicemailsFilter } from "../../actions/voicemailActions";
import uiString from "../../constants/uiString";
import { domIds } from "@constants/testConstants";
import { useAppSelector } from "@helpers/hooks/useAppSelector.hook";
import DropdownComponent from "../PresentationComponents/DropdownComponent";

const VoicemailFilter: React.FC = () => {
  const filterBy = useAppSelector((state) => state.voicemails.filterBy);
  const voicemails = useAppSelector((state) => state.voicemails.data);
  const voicemailMailboxes = useAppSelector(
    (state) => state.voicemails.mailboxes
  );
  const dispatch = useDispatch();
  /**
   * Display the filter dropdown only if there is more than 1 mailbox to filter by
   *
   * @param voicemailMailboxes the user's mailboxes
   * @param filterBy the mailbox
   */

  /**
   * Called when the dropdown value has changed
   *
   * @param event the syntethic event generated by the dropdown
   * @param data contains data about the change
   */
  const filterDropdownValueChanged = (name: string | undefined, value: unknown) => {
    applyFilter(value);
  };

  /**
   * Apply filter on all voicemail entries
   *
   * @param filterBy the phone number to filter entried by
   */
  const applyFilter = (filterBy) => {
    dispatch(applyVoicemailsFilter(voicemails, filterBy));
  };

  // Allow the use of a filter if we have at least 1 mailbox
  const minimumMailboxes = 1;
  let dropdownOptions = [
    {
      value: uiString.ALL_MAILBOXES,
      text: uiString.ALL_MAILBOXES,
    },
  ];
  let disabled = true;

  if (
    Array.isArray(voicemailMailboxes) &&
    voicemailMailboxes.length >= minimumMailboxes
  ) {
    disabled = false;
    dropdownOptions = [
      ...dropdownOptions,
      ...voicemailMailboxes.map((entry) => {
        const { id, description, messageCount } = entry;
        return {
          value: id,
          text: `${description} (${messageCount})`,
        };
      }),
    ];
  }

  return (
    <DropdownComponent
      id={domIds.VOICEMAIL_FILTER_DROPDOWN}
      className="text-normal"
      disabled={disabled}
      value={filterBy}
      placeholder={uiString.ALL_MAILBOXES}
      options={dropdownOptions}
      onChange={e => filterDropdownValueChanged(e.target.name, e.target.value)}
      smallIcon
      boldColor
      dropdownStyle={{marginLeft: 12, marginTop: 3, letterSpacing: 0.5}}
    />
  );
};

export default VoicemailFilter;